import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bachelor-of-computer-application',
  templateUrl: './bachelor-of-computer-application.component.html',
  styleUrls: ['./bachelor-of-computer-application.component.scss']
})
export class BachelorOfComputerApplicationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
